// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f69bd917","498":"4b4a3094","703":"8862db9f","787":"eec4b31a"}[chunkId] + ".chunk.js";
};